import React from "react"
import { Link } from "gatsby"
import { Container, Breadcrumb, BreadcrumbItem, Row, Col } from "reactstrap"
import Layout from "./../components/layout"
import SEO from "./../components/seo"
import "../style/products.css"
import "../style/replication.css"

function Replication() {
  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <Link className="breadCrumbLinks" to="/">
            Home
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link className="breadCrumbLinks" to="/products">
            Products
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Replication</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <h1>DARSTRAN</h1>
        <h3
          style={{
            textAlign: "center",
          }}
        >
          Replicate your Data in an RDBMS and/or <em>The Cloud</em> and keep it
          Instantly Synchronized
        </h3>
        <h4
          style={{
            textAlign: "center",
            backgroundColor: "#2780E3",
            color: "white",
            padding: "5px"
          }}
        >
          The Innovative Evolution of The Industry-Leading CA IDMS® Replication
          Toolset
        </h4>
        <nav id="rep-nav">
          {/* <nav id="nav" style={{ margin: "0", marginTop: "40px" }}> */}
          <div className="nav-container">
            <ul className="nav-ul">
              <li className="nav-li">
                <Link className="productLinks" to="/replication#features">
                  Features
                </Link>
                <span className="dividers">{" | "}</span>
              </li>
              <li className="nav-li">
                <Link className="productLinks" to="/replication#components">
                  Components
                </Link>
                <span className="dividers">{" | "}</span>
              </li>
              <li className="nav-li">
                <Link className="productLinks" to="/replication#benefits">
                  Benefits
                </Link>
              </li>
            </ul>
          </div>
        </nav>
        <h2 class="h2s" id="features">
          Features
        </h2>
        <Row>
          <Col xs="12">
            <ul className="features-ul">
              <li>
                No CA IDMS database access is performed except to extract the CA
                IDMS data for Initial Load of the target RDBMS
              </li>
              <li>
                The core DARSTRAN Replication Engine© and Journal Image
                Processor© have been designed and written to run on a full range
                of popular target platforms, including the mainframe. Common
                code for all platforms ensures high performance, reliability and
                identical replication on all platforms
              </li>
              <li>
                The core DARSTRAN Replication Engine© and Journal Image
                Processor© provide superior performance and reliabilty when
                capturing updates from the Active CV Journals. Updates are
                processed at COMMIT and/or FINISH and sent to the target
                platform using the guaranteed delivery provided by{" "}
                <em>IBM's MQSeries®</em>
              </li>
              <li>
                Unlike some other replication tools, No application or CA IDMS®
                system modifications such as HOOKs, EXITs or DBPROCs are used
                that could seriously impact and/or destabilize your CVs
              </li>
              <li>
                The innovative design allows ISP to offer optional components to
                CA IDMS® Network and CA IDMS/SQL® database users who require
                data replication to DB2 or CA IDMS/SQL on z/OS; DB2, DB2UDB, MS
                SQLServer, MySQL, Oracle, and Sybase on Windows 2000/2003/2008
                Server®, and/or on AIX®/Unix/Linux based and/or on zLinux
                platforms where the respective RDBMS is supported. Both 32 bit
                and 64 bit are available as required
              </li>
              <li>
                The user may optionally generate XML to process the replicated
                data with a variety of third party software products
              </li>
              <li>
                There is no requirement to copy the client's database files for
                processing off site. All CA IDMS data processing is performed at
                the client's site under the client's scrutiny and security
                control
              </li>
              <li>
                The CA IDMS Metadata can be extracted and loaded into your RDBMS
                of choice for use with various Reporting, Analysis and Drawing
                Tools. With our Active Journal feature, the RDBMS TABLEs will be
                kept in sync with the CA IDMS IDD
              </li>
              <li>
                Mutiple targets and Clouds can be synchronized from a single
                DARSTRAN instance
              </li>
            </ul>
          </Col>
        </Row>
        <hr />
        <h2 class="h2s" id="components">
          Components
        </h2>
        <Row>
          <Col xs="12" md="2">
            <h5>DARSWIN©</h5>
          </Col>
          <Col xs="12" md="10">
            <ul className="components-ul">
              <li>Transforms CA IDMS® Schema syntax to RDBMS DDL</li>
              <li>
                Addresses CA IDMS® Schema changes that affect an
                already-configured DARSTRAN©
              </li>
              <li>
                Eliminates the manual updating of replication definitions after
                CA IDMS® Schema changes
              </li>
              <li>
                Accepts updated Schema syntax, compares it to the original,
                reports on the differences and automatically incorporates the
                changes into the replication definition
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col xs="12" md="2">
            <h5>DARSTRAN©</h5>
          </Col>
          <Col xs="12" md="10">
            <ul className="components-ul">
              <li>
                Provides complete data formatting on the mainframe or target
                platforms
              </li>
              <li>
                Reassembles and transforms Initial Load CA IDMS® extract data
                and CA IDMS® Journal images into either Fast Load syntax, SQL
                statements or XML
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col xs="12" md="2">
            <h5>DARSLOAD©</h5>
          </Col>
          <Col xs="12" md="10">
            <ul className="components-ul">
              <li>
                Implemented as a Service for Windows NT® and as a Daemon for
                AIX®/Unix/Linux to eliminate the need for scripting on the
                target platform
              </li>
              <li>
                Invokes DARSTRAN© to perform the required data transformations
                and manages the application of the data to the target RDBMS
              </li>
              <li>
                Configurable to facilitate multiple simultaneous Initial Data
                Loads to greatly reduce target RDBMS run times
              </li>
              <li>Incorporates ERROR logging facilities</li>
            </ul>
          </Col>
        </Row>
        <hr />
        <h2 class="h2s" id="benefits">
          Benefits
        </h2>
        <Row>
          <Col xs="12" md="2">
            <h5>Cost Savings & Performance</h5>
          </Col>
          <Col xs="12" md="10">
            <ul className="components-ul">
              <li>
                DARSTRAN© reduces the impact on mainframe resources through
                highly optimized code and, optionally, by moving the Archive
                Journal processing to the target platform
              </li>
              <li>
                Near Real-Time target updates are achieved using the
                sophisticated Active Journal facility in conjunction with the
                speed, reliability and guaranteed message delivery of IBM'S
                MQSeries© software running on the mainframe and target platforms
              </li>
              <li>
                Replicate to an RDBMS and/or the Cloud in the same DARSTRAN
                instance
              </li>
              <li>Sysplex aware</li>
              <li>
                Dramatic performance improvements may be realized if the
                parallel processing features of DARSLOAD© are fully exploited in
                installations where the available CPU cycles on the target
                platform exceed those available on the mainframe
              </li>
            </ul>
            <p>
              <strong>Note:</strong> Journal processing requiring decompression
              using CA PRESSPACK® is only supported on the mainframe. This is a
              limitation of the CA-PRESSPACK® code and not DARSTRAN®
            </p>
          </Col>
          <Col xs="12" md="2">
            <h5>Resolution of SET OWNER Relationships</h5>
          </Col>
          <Col xs="12" md="10">
            <ul className="components-ul">
              <li>
                Built-in logic dynamically computes OWNER pointer values for a
                SET where OWNER pointers are not defined in CA IDMS® by using
                the SET’s NEXT pointer within the replica. Absolutely NO access
                to the CA IDMS® application database is required to formulate
                the relationship
              </li>
              <li>
                Predictable response times plus elimination of “dirty reads” of
                the CA IDMS® application database result in substantial
                performance benefits
              </li>
            </ul>
          </Col>
          <Col xs="12" md="2">
            <h5>Comprehensive Error Logging</h5>
          </Col>
          <Col xs="12" md="10">
            <ul className="components-ul">
              <li>Extensive Error logging facilities</li>
              <li>
                Formatted for loading into an RDBMS table for query and analysis
              </li>
              <li>
                Includes logging of invalid Dates and Elements that contain data
                that does not match the defined Data Type
              </li>
              <li>
                Flexible error detection provides logging of information at the
                Schema, Record, or Element level
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Replication
